import React, { useState } from "react";
import { Icon } from "@iconify/react";
import Button from "../../Components/Button";

export const initialOptions = [
    {
        label: "Request a tour",
        subLabel: "Schedule a visit to explore the centre",
        id: 2,
        steps: 1,
        icon: "fa6-solid:flag",
    },
    {
        label: "Fees",
        subLabel: "Learn about the costs /payment options",
        id: 3,
        steps: 2,
        icon: "fa6-solid:circle-dollar-to-slot",
    },
    {
        label: "Availability",
        subLabel: "Check spots open for your child",
        id: 1,
        steps: 3,
        icon: "fa6-solid:circle-check",
    },
    {
        label: "Programs",
        subLabel: "Discover educational activities offered",
        id: 6,
        steps: 4,
        icon: "fa6-solid:cubes",
    },
    {
        label: "Other",
        subLabel: "Ask about anything not listed above",
        id: 5,
        steps: 5,
        icon: "fa6-solid:circle-question",
    },
];

const LIVE_TOUR = {
    label: "Book a Tour",
    subLabel: "Schedule a visit to explore the centre",
    id: 4,
    steps: 3,
    icon: "fa6-solid:flag",
};

type Option = typeof LIVE_TOUR;

interface IStartEnquiryProps {
    [key: string]: any;
    onNext: (payload: { data: any }) => void;
}

function StartEnquiry(props: IStartEnquiryProps) {
    const { isLiveTourBookingAvailable, enquiryDetail, onNext, submitGa4 } =
        props;
    const [selectedOptions, setSelectedOptions] = useState<Option[]>(
        enquiryDetail?.startEnquiry?.length > 0 ? enquiryDetail.startEnquiry : []
    );
    const options = isLiveTourBookingAvailable
        ? initialOptions.slice(1)
        : initialOptions;

    const onItemClick = (option: Option) => {
        if (option.id === LIVE_TOUR.id) {
            const isSelectedLiveTour = selectedOptions.some(
                (item) => item.id === option.id
            );
            setSelectedOptions(isSelectedLiveTour ? [] : [option]);
        } else {
            const filteredLiveTour = selectedOptions.filter(
                (item) => item.id !== LIVE_TOUR.id
            );
            if (selectedOptions.some((item) => item.id === option.id)) {
                setSelectedOptions(
                    filteredLiveTour.filter((item) => item.id !== option.id)
                );
            } else {
                setSelectedOptions([...filteredLiveTour, option]);
            }
        }
    };

    const handleSubmit = () => {
        if (selectedOptions.length) {
            //submitGa4(`general-enquiry-${selectedOptions.map((item) => item.label).join('-')}`)
            onNext({
                data: selectedOptions,
            });
        }
    };
    return (
        <div className="text-[#3A3A3A] pb-24 lg:pb-0">
            <h2 className="text-[22px] font-semibold leading-7 mb-6 text-[#3A3A3A]">
                {props.isLiveTourBookingAvailable
                    ? "Select an option"
                    : "What would you like to enquire about?"}
            </h2>
            {props.isLiveTourBookingAvailable && (
                <>
                    <p className="text-[16px] font-medium mb-4 leading-7 text-[#3A3A3A]">
                        Book a Tour
                    </p>
                    <div
                        className={`relative lg:max-w-[308px] cursor-pointer w-full p-4 rounded-lg space-y-2 border ${selectedOptions.some((item) => item.id === LIVE_TOUR.id)
                                ? "bg-[#E1E8FE] border-[#5A60EC]"
                                : "bg-[#F9F7F3] border-[#F7F7F8]"
                            }`}
                        onClick={() => onItemClick(LIVE_TOUR)}
                        key={LIVE_TOUR.id}
                    >
                        <div className="absolute right-2 bg-[#FFCBE2] ml-auto rounded-[4px] px-2 py-1 w-fit flex gap-2 text-[#EA1859] font-medium text-[12px]">
                            <Icon
                                icon="fa6-solid:fire"
                                width="14"
                                height="16"
                                style={{ color: "#EA1859" }}
                            />
                            Hot Pick
                        </div>
                        <div className="flex gap-x-4 items-center pr-[80px]">
                            <Icon
                                icon={LIVE_TOUR.icon}
                                className="text-berry text-1xl"
                            ></Icon>
                            <span className={`text-[#5A60EC] text-base font-medium`}>
                                {LIVE_TOUR.label}
                            </span>
                        </div>
                        <p className="text-xs leading-4">{LIVE_TOUR.subLabel}</p>
                    </div>
                </>
            )}
            {props.isLiveTourBookingAvailable ? (
                <p className="font-medium mt-6 leading-6 text-base">
                    ...Or make an enquiry
                </p>
            ) : (
                <p className="font-medium leading-6 text-base">
                    Select as many options as you want
                </p>
            )}

            <div className="text-base lg:mt-6 mt-4 space-y-4 lg:max-w-[308px]">
                {options.map((item) => {
                    const isActive = selectedOptions.some(
                        (option) => item.id === option.id
                    );
                    return (
                        <div
                            className={`cursor-pointer w-full p-4 rounded-lg space-y-2 border ${isActive
                                    ? "bg-[#E1E8FE] border-[#5A60EC]"
                                    : "bg-[#F9F7F3] border-[#F9F7F3]"
                                }`}
                            onClick={() => onItemClick(item)}
                            key={item.id}
                        >
                            <div className="flex gap-x-4 items-center">
                                <Icon icon={item.icon} className="text-berry text-1xl"></Icon>
                                <span className={`text-[#5A60EC] text-base font-medium`}>
                                    {item.label}
                                </span>
                            </div>
                            <p className="text-xs leading-4">{item.subLabel}</p>
                        </div>
                    );
                })}
            </div>
            <div className="fixed bottom-0 left-0 right-0 bg-white p-4 md:pt-10 border-t border-gray-200 flex justify-center z-10 lg:static lg:bg-transparent lg:border-0 lg:justify-center lg:ml-[-340px]">
                <Button
                    type="button"
                    variant="primary"
                    onClick={handleSubmit}
                    disabled={selectedOptions.length === 0}
                    customClass="w-full lg:w-fit lg:md:mb-0 disabled:bg-[#E3E1DD] enquiry-option next-button-step-1"
                >
                    Next
                </Button>
            </div>
        </div>
    );
}

export default StartEnquiry;
